'use client';

import { useAuthMutations, useFirebaseAuthMutations } from './mutations';

import { APP_ROUTES } from '@/routes';
import type { AuthStore } from '../stores/useAuthStore';
import { useAuthStore } from '../stores/useAuthStore';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useSession } from './queries';
import { useToast } from '@packages/chakra-v3';

export type UseSessionReturn = {
	user:    AuthStore['user'];
	status:  AuthStore['status'];
	refresh: () => void;
	signOut: () => void;
};

export const useAuthSession = () => {
	const router = useRouter();
	const { showSuccess } = useToast();
	const authStore = useAuthStore();
	const sessionQuery = useSession(authStore.user);
	const { firebaseLogoutMutation } = useFirebaseAuthMutations();
	const { logoutMutation } = useAuthMutations();

	useEffect(() => {
		if (sessionQuery.error) {
			authStore.clear();
			router.replace(APP_ROUTES.AUTH.LOGIN);
		}

		// Update user data when session check succeeds
		if (sessionQuery.isSuccess) {
			authStore.setAuthStore({
				user:   sessionQuery.data.session,
				status: 'authenticated',
			});
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ sessionQuery.error, sessionQuery.isSuccess ]);

	// TODO Remove this and give it own hook
	const handleSignOut = async() => {
		await firebaseLogoutMutation.mutateAsync();
		await logoutMutation.mutateAsync({}, {
			onSuccess() {
				authStore.clear();
				showSuccess({ title: 'Logout successful' });
				router.push(APP_ROUTES.HOME);
			},
		});
	};

	return {
		user:    authStore.user,
		status:  authStore.status,
		signOut: handleSignOut,
	};
};